import React from 'react'
import { Link } from "react-router-dom";
import logo from "../assets/images/logo2.png"
import android from "../assets/images/android.png"
import androidim from "../assets/images/androidim.png"
import Nav from './headerlinks';
import { HamMenuBtn } from './hammenu';

const Header = ({headerbg}) => (
    <div className="top-header headerheight" style={{background: headerbg || '#feec6b'}}>
        <div className="container">
            <div className="flex-between">
                <div className="flex-between">
                    <div className="logo-image">
                    <Link to="/">
                        <img src={logo} alt="" />
                    </Link>
                    </div>
                    <div className="android-image">
                    <img src={android} alt="" />
                    </div>
                    <div className="android-image">
                    <img src={androidim} alt="" />
                    </div>
                   
                </div>
                <div className="menu flex-center">
                    <Nav />
                    <HamMenuBtn />
                </div>
            </div>
        </div>
    </div>
)

export default Header
